/**
 * Auto-generated TypeScript types from OpenAPI specification
 * 
 * Title: App Template API
 * Version: 1.0.0
 * 
 * DO NOT EDIT THIS FILE DIRECTLY
 */

  import type {
    ListProductsResponse,
    ListProductsParams,
    GetProductResponse
  } from '@app/shared/types';
  import type { AxiosResponse } from 'axios';
  import { apiClient } from './apiClient';
  import {
  useQuery, type UseQueryOptions
  } from '@tanstack/react-query';


/**
 * List products with optional filtering and pagination
 * 
 * @endpoint GET /products
 */
export const listProducts = (params?: ListProductsParams): Promise<AxiosResponse<ListProductsResponse>> => {
  return apiClient.get<ListProductsResponse>('/products', { params });
};



/**
 * Get a single product by ID
 * 
 * @endpoint GET /products/{id}
 */
export const getProduct = (pathParams: { id: string | number }): Promise<AxiosResponse<GetProductResponse>> => {
  return apiClient.get<GetProductResponse>(`/products/${pathParams.id}`);
};



/**
 * List products with optional filtering and pagination
 * 
 * @endpoint GET /products
 */
export const useListProducts = (params: ListProductsParams, options?: UseQueryOptions<ListProductsResponse>) => {
  return useQuery<ListProductsResponse>({
    queryKey: ['listProducts', params],
    queryFn: async () => {
      const { data } = await listProducts(params);
      return data;
    },
    ...options,
  });
};



/**
 * Get a single product by ID
 * 
 * @endpoint GET /products/{id}
 */
export const useGetProduct = (pathParams: { id: string | number }, options?: UseQueryOptions<GetProductResponse>) => {
  return useQuery<GetProductResponse>({
    queryKey: ['getProduct', pathParams],
    queryFn: async () => {
      const { data } = await getProduct(pathParams);
      return data;
    },
    ...options,
  });
};

